import React from 'react';
import { observer } from "mobx-react-lite";
import { Popup, PopupHeadline } from '../shared/Popup';
import { UiConstants } from '../../data/UiConstants';
import { EnemyCombatPresetEditor } from './EnemyCombatPresetEditor';
import { undoableDeselectEnemyCombatPreset } from '../../stores/undo/operation/CombatEnemyCombatPresetSelectionOp';
import { useTranslation } from 'react-i18next';
import { combatEditorStore } from '../../stores/CombatEditorStore';
export const EnemyCombatPresetEditorPopup = observer(() => {
  const {
    t
  } = useTranslation();
  const {
    selectedEnemyCombatPreset
  } = combatEditorStore;
  if (!selectedEnemyCombatPreset) return null;
  return /*#__PURE__*/React.createElement(Popup, {
    closePopup: undoableDeselectEnemyCombatPreset,
    zIndex: UiConstants.Z_INDEX_ENEMY_COMBAT_PRESET_EDITOR_POPUP,
    windowStyle: {
      minWidth: "600px"
    }
  }, /*#__PURE__*/React.createElement(PopupHeadline, null, t("editor.combat_enemy_combat_preset")), /*#__PURE__*/React.createElement(EnemyCombatPresetEditor, {
    enemyCombatPreset: selectedEnemyCombatPreset
  }));
});